import React from "react"
import Dropdown from "../../components/Dropdown"
import Button from "../../components/Button"

export const EtrInsightsCalendarPurchaseCardsSection = ({
  model,
  className = "",
}) => {
  const {
    isSpecialAccess,
    free,
    files,
    product,
    selectedFile,
    slug,
    selectFile,
    download,
    isProductAvailable,
    renderRequestAccess,
    view,
  } = model

  const canDownload =
    isProductAvailable && files && files.length && (free || isSpecialAccess)

  if (isSpecialAccess || free) {
    if (files && !files.length) {
      return (
        <div className={[className, "etr-insights-details-no-files"].join(" ")}>
          Files not available at the moment.
        </div>
      )
    }

    let file = files[selectedFile]
    return (
      file && (
        <div id="file-selector" className={className}>
          <div className="etr-insights-details-buttons-container">
            <Dropdown
              defaultValue={selectedFile}
              label="File Type:"
              options={files.map(({ name }, i) => ({
                name,
                value: i,
              }))}
              onChange={selectFile}
            />
          </div>
          <div className="etr-insights-details-buttons-container">
            <div className="button-item">
              <Button
                classes={["btn", "btn-light", "btn-outline"]}
                fullWidth
                disabled={!canDownload}
                action={() => view(product, selectedFile)}
              >
                View {file.name}
                <span
                  className="glyphicon glyphicon-eye-open"
                  style={{ marginLeft: 5 }}
                />
              </Button>
            </div>
            <div className="button-item">
              <Button
                classes={["btn", "btn-light", "btn-outline"]}
                fullWidth
                download={`/products/${slug[0]}?item=${selectedFile}`}
                action={download(selectedFile, product)}
                disabled={!canDownload}
              >
                Download {file.name}{" "}
                <span
                  className="glyphicon glyphicon-download-alt"
                  style={{ marginLeft: 5 }}
                />
              </Button>
            </div>
          </div>
        </div>
      )
    )
  } else if (isProductAvailable(product)) {
    return (
      <div
        className={[className, "etr-insights-details-buttons-container"].join(
          " "
        )}
      >
        {renderRequestAccess(product)}
      </div>
    )
  } else {
    return (
      <div
        className={[className, "etr-insights-details-buttons-container"].join(
          " "
        )}
      >
        {renderRequestAccess(product)}
      </div>
    )
  }
}
